import { ComponentStyleConfig } from '@chakra-ui/react';

export const ImageCrop: ComponentStyleConfig = {
  baseStyle: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    img: {
      pointerEvents: 'none',
      objectFit: 'cover',
      objectPosition: 'center',
      minWidth: 136,
      minHeight: 136,
      maxHeight: 368,
    },
    '.ReactCrop__child-wrapper': {
      cursor: 'default',
      width: '100%',
    },
    '> div:first-of-type': {
      height: '100%',
      width: '100%',
    },
    '.ReactCrop__crop-selection': {
      border: `1px solid`,
      borderColor: 'white',
      borderRadius: 8,
    },
    '.ReactCrop__drag-handle': {
      '&.ord-nw, &.ord-ne, &.ord-se, &.ord-sw': {
        '&::after': {
          border: 'none',
          borderRadius: '100%',
          background: 'white',
          width: 4,
          height: 4,
        },
      },
      '&.ord-nw': {
        marginTop: -2,
        marginLeft: -2,
      },
      '&.ord-ne': {
        marginTop: -2,
        marginRight: -2,
      },
      '&.ord-se': {
        marginBottom: -2,
        marginRight: -2,
      },
      '&.ord-sw': {
        marginBottom: -2,
        marginLeft: -2,
      },
    },
  },
};
